
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaCross, FaTrash } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ToggleButton } from 'primereact/togglebutton';
import { func } from 'prop-types';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import {Mandate} from '../../compnents/formcomp';

const BudgetClientwise = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        selectedclient: '',
        monthmdl:'',
        budgetmdl:''
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [usercomp,setUsercomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState({'client':'','budget':''});
    const [errors, setErrors] = useState({});
    const [editerrors, seteditErrors] = useState({});
    const [newobjdata, setNewobj] = useState({});
    const [isclientmerge, setclientmerge] = useState(false);
    
     
    useEffect(()=>{
        getallclient();
        // getclientwisebudget();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
    
        }catch(e){
            console.log(e);
        }
        
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        if (formData.selectedclient == '') {
            newErrors.selectedclient = 'Client is required';  
            valid = false;
        }

        if (formData.monthmdl == '') {
            newErrors.monthmdl = 'Month is required';
            valid = false;
        }

        if (formData.budgetmdl == '') {
            newErrors.budgetmdl = 'Budget is required'; 
            valid = false;
        }
        setErrors(newErrors);
       return valid; 
    }

    const validateForm2 = () => {
        let valid = true;
        const newErrors = {};
        if (formData.selectedclient == '') {
            newErrors.selectedclient = 'Client is required';  
            valid = false;
        }

        if (formData.monthmdl == '') {
            newErrors.monthmdl = 'Month is required';
            valid = false;
        }
        setErrors(newErrors);
       return valid;  
    }

    function opentoggle(value){
        setclientmerge(true);    
        seteditobj(value); 
        console.log(value);
    }

    function clientdisplay(){
         try{
            let emparr = [];
             if(datacomp == undefined || datacomp.length <= 0){
                  return emparr;
             }
             datacomp.forEach((value,index)=>{
                // console.log(value.name);
                let checked = false;
                if(value.allowed == 'allowed'){
                    checked = true; 
                }else{
                    checked = false; 
                }
    
                emparr.push(<tr>
                     <td>{index + 1}</td>
                     <td>{value.client}</td>
                     <td>{value.month}</td>
                     <td>{value.budget}</td>
                     <td>{value.services}</td>
                     <td>{value.bywhom}</td>
                    
                     <td><button type='button' className='btn btn-success' onClick={() => opentoggle(value)}><FaEdit/></button></td>
                </tr>);
            }); 
    
            return emparr;
        }catch(error){
          return [];
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
       addbudgetclient();
    };


    const editchange = (e) => {
        try{
            editobj.budget = e.target.value;
            editobj.budgettemp = e.target.value;
             console.log(editobj);
           
        }catch(e){
            console.log(e);
        }
    };
    const validateFormedit = () => {
        let valid = true;
        const newErrors = {};
        if (editobj.client == '') {
            newErrors.client = 'Client is required';
            valid = false;
        }

        if (editobj.budget == '') {
            newErrors.budget = 'Budget is required'; 
            valid = false;
        }
        seteditErrors(newErrors);
        return valid; 
    }

    const handleeditSubmit = (e) => {
        e.preventDefault();
       
        if(!validateFormedit()){
            return;
        }
        let obj = JSON.stringify(editobj); 
        timesheetService.updatebudgetclient({formdata:obj}).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Client budget', detail: 'Updated successfully', life: 3000 });
                getclientwisebudget();
                setclientmerge(false);
            }else{
                toast.current.show({ severity: 'error', summary: 'Client budget', detail: 'Not updated', life: 3000 }); 
            }
       }).catch((error)=>{
          toast.current.show({ severity: 'error', summary: 'Client budget', detail: 'Error', life: 3000 }); 
       });
        console.log();

    //    addbudgetclient();
    };

    function addbudgetclient(){
      formData.month = formatterhelper.dateformatter({date:formData.monthmdl});
      let obj = JSON.stringify(formData); 

      timesheetService.addbudgetclient({formdata:obj}).then((response)=>{
        //   console.log(response);
          if(response.status == 200){
            toast.current.show({severity:'success', summary: "Client Budget", detail:`Client budget added`, life: 3000}); 
            getclientwisebudget();  
           }else{
            toast.current.show({severity:'error', summary: "Client Budget", detail:`Client budget not added`, life: 3000}); 
          }
      }).catch((error)=>{
        toast.current.show({severity:'error', summary: "Client Budget", detail:`Error`, life: 3000}); 
      }); 
    }
 
    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    function getclientwisebudget(){
        if(!validateForm2()){
            return;
        } 

        setloading(false);
        formData.month = formatterhelper.dateformatter({date:formData.monthmdl}); 
        let obj = JSON.stringify(formData); 
        timesheetService.getclientwisebudget2({formdata:obj}).then((response)=>{
           if(response.status == 200){
            //    console.log(response.data.data);
             setDatacomp(response.data.data);
             setloading(true);
           }else{
            setDatacomp([]);  
            setloading(true);
           }
        }).catch((error)=>{
           console.log(error); 
           setloading(true);
           setDatacomp([]);  
        });
    }

 return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog /> 
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
             <Dialog header="Client Budget" visible={isclientmerge} style={{ width: '60vw' }} onHide={() => {setclientmerge(false);getclientwisebudget()}}>
                 <form onSubmit={(e)=>handleeditSubmit(e)}>
                     <div className='col-md-12'>

                     <div className='row'>
                        <div className='col-md-3'>
                           <label><Mandate/> Client</label>
                           <input type='text' value={editobj.client} disabled name='client'  class="form-control"  />
                           {editerrors.client && <span className='error'>{editerrors.client}</span>}
                        </div> 

                        <div className='col-md-3'>
                           <label><Mandate/> Budget</label>
                           <input type='number' defaultValue={editobj.budget}  name='budget'  class="form-control"  onChange={(e) => editchange(e)}/>
                           {editerrors.budget && <span className='error'>{editerrors.budget}</span>}
                        </div> 
                     </div>

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 <Button type="submit" label="Save" severity="success" rounded />
                              </span>

                              <span>
                                 <Button type="button" label="Close" severity="danger" rounded onClick={() => {setclientmerge(false);getclientwisebudget()}} />
                              </span>
                           </div>
                        </div>
                     </div>
                     </div>
                 </form>
             </Dialog>
            
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className='col-md-12'>
                <div className='row'>
                     <div className='col-md-12'>
                     {/* <Message severity="info" text="Note:
Please ensure that during the process of renaming, certain considerations are taken into account:

1) While adding clients or subclients, please ensure they are present.
2) Please double-check spelling.
" /> */}

                     
                     </div> 
                    
                   <div className="col-md-4">
                   <br/>
                        <label className='pull-left'><Mandate/> Client</label>
                        <br/>
                        <select className='custom-dropdown-style' name="selectedclient" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           <option value="all">ALL</option>
                           {clientcomp}
                        </select>
                        
                        {errors.selectedclient && <span className='error'>{errors.selectedclient}</span>}
                    </div>

                    <div className="col-md-4">
                       <br/>
                        <label className='pull-left'><Mandate/> Select Month</label>
                        <Calendar view="month" value={formData.monthmdl} name="monthmdl" onChange={(e) => handleChange(e)} className='calender-custom-style custom-width-style' />
                        <br/>
                        {errors.monthmdl && <span className='error'>{errors.monthmdl}</span>}
                    </div> 

                     <div className="col-md-4">
                       <br/>
                        <label className='pull-left'><Mandate/> Add budget</label>
                        <input type='number' name="budgetmdl"  className='form-control'  onChange={(e) => handleChange(e)}/>
                        <br/>
                        {errors.budgetmdl && <span className='error'>{errors.budgetmdl}</span>}
                    </div>  

                    <div className="col-md-4 col-sm-4">
                      
                      <div className='container-box'>
                         <div className='button-wrapper-style'>
                            <Button type='button'  label="Show" onClick={() => getclientwisebudget()} severity="success" rounded className='custom-btn-style col-md-12' />
                        </div>
                        &nbsp;
                        &nbsp;

                        <div className='button-wrapper-style'>
                           {formData.selectedclient != 'all' ? (<Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' />) : (<></>)} 
                        </div>  
                      </div>
                       
                     </div>
                </div>
                <br/>
                <br/>
               
                </div>
               
                </div>
                </form>
                <div className='col-md-12'>
                    <br/>
                    {!isloaded ? loader.Loadermd() : datacomp.length > 0 ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col" style={{width:'100px'}}>Date</th>
                                <th scope="col">Budget Hrs</th>
                                <th scope="col">Services</th>
                                <th scope="col">By whom</th>
                                <th scope="col">Action</th>  
                            </tr>
                        </thead>
                        <tbody>
                            {clientdisplay()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                   
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default BudgetClientwise;
